import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { patentFields, classNumbers, saleMethodLabel, designatedGoodsText } from "src/libs/portal/season/market-catalog";

interface ListingFile {
    filename: string;
    size: number;
    mimeType: string;
    documentType: string;
    visibility: 'PUBLIC';
    url: string;
}

interface Listing {
    id: string;
    imageUrl?: string;
    isExample?: boolean;
    exampleSource?: string;
    exampleNote?: string;
    designatedGoods?: any;
    productName?: string;
    trademarkClasses?: Array<string | number>;
    designClasses?: Array<string | number>;
    rightType: string;
    field: string;
    category: string;
    registrationNumber: string;
    registrationDate: string;
    applicationNumber?: string;
    applicationDate?: string;
    title: string;
    summary: string;
    status: string;
    price: number;
    saleMethod: string;
    saleMethods: string[];
    negotiable: boolean;
    licenseAvailable: boolean;
    ownerDisplay: string;
    tags: string[];
    files: ListingFile[];
    publishedAt: string;
}

@Component({
    selector: 'wiz-page-ip-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.item/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
}

.ip-detail-page {
  min-height: calc(100vh - 70px);
  padding: 34px 0 76px;
  color: #14251d;
}

.ip-detail-content,
.ip-detail-state {
  width: min(1180px, 100% - 40px);
  margin: 0 auto;
}

.ip-detail-content {
  transition: filter 0.18s ease, opacity 0.18s ease;
}
.ip-detail-content.is-dimmed {
  filter: blur(5px);
  opacity: 0.68;
  pointer-events: none;
  user-select: none;
}

.ip-detail-kicker {
  margin: 0;
  color: #0b7a51;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.18em;
  line-height: 1.4;
}

.ip-detail-breadcrumb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  min-height: 34px;
  margin-bottom: 16px;
}
.ip-detail-breadcrumb > div {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #93a098;
  font-size: 11px;
}
.ip-detail-breadcrumb a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #51645a;
  font-weight: 800;
  text-decoration: none;
}
.ip-detail-breadcrumb a:hover {
  color: #0b7450;
}
.ip-detail-breadcrumb svg {
  width: 15px;
  height: 15px;
}
.ip-detail-breadcrumb strong {
  color: #31483c;
  font-weight: 800;
}

.ip-detail-live {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 28px;
  padding: 0 11px;
  border: 1px solid #d9e3dd;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  color: #6f8177;
  font-size: 10px;
  font-weight: 900;
}
.ip-detail-live i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #8b9991;
}
.ip-detail-live.is-live {
  border-color: #bfdfcc;
  background: #eaf8ef;
  color: #147248;
}
.ip-detail-live.is-live i {
  background: #22aa64;
  box-shadow: 0 0 0 4px rgba(34, 170, 100, 0.12);
}

.ip-detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 346px;
  align-items: start;
  gap: 22px;
}

.ip-detail-main,
.ip-detail-aside {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ip-detail-hero {
  position: relative;
  overflow: hidden;
  padding: 34px 36px 0;
  border: 1px solid rgba(152, 190, 169, 0.7);
  border-radius: 23px;
  background: radial-gradient(circle at 92% -22%, rgba(114, 203, 147, 0.36), transparent 38%), linear-gradient(140deg, #fbfefc 0%, #eff8f2 62%, #e8f4ec 100%);
  box-shadow: 0 23px 55px rgba(29, 74, 47, 0.1);
}
.ip-detail-hero::after {
  position: absolute;
  right: 12%;
  top: -58px;
  width: 1px;
  height: 270px;
  background: linear-gradient(transparent, rgba(33, 109, 66, 0.15), transparent);
  transform: rotate(25deg);
  content: "";
}
.ip-detail-hero h1 {
  position: relative;
  z-index: 1;
  max-width: 790px;
  margin: 18px 0 11px;
  color: #10261b;
  font-size: clamp(25px, 3vw, 38px);
  font-weight: 850;
  letter-spacing: -0.045em;
  line-height: 1.22;
  overflow-wrap: anywhere;
}

.ip-detail-hero-top {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.ip-detail-taxonomy {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ip-detail-taxonomy span {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 11px;
  border: 1px solid rgba(189, 208, 197, 0.88);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  color: #5d7267;
  font-size: 10px;
  font-weight: 850;
}
.ip-detail-taxonomy .is-primary {
  border-color: #a9d8bc;
  background: #dff3e7;
  color: #126c43;
}

.ip-detail-serial {
  max-width: 270px;
  overflow: hidden;
  color: #779087;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ip-detail-summary {
  position: relative;
  z-index: 1;
  max-width: 720px;
  margin: 0;
  color: #60766b;
  font-size: 13px;
  line-height: 1.8;
}

.ip-detail-primary-publication {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 190px;
  min-height: 260px;
  margin: 24px 0 0;
  overflow: hidden;
  border: 1px solid rgba(169, 195, 180, 0.8);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 15px 34px rgba(29, 74, 47, 0.1);
}
.ip-detail-primary-publication img {
  width: 100%;
  height: 100%;
  max-height: 460px;
  object-fit: contain;
  background: #f6faf7;
}
.ip-detail-primary-publication figcaption {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 8px;
  padding: 22px;
  border-left: 1px solid rgba(190, 210, 198, 0.72);
  background: linear-gradient(155deg, rgba(238, 248, 241, 0.9), rgba(255, 255, 255, 0.95));
}
.ip-detail-primary-publication figcaption strong {
  color: #126c43;
  font-size: 13px;
  font-weight: 850;
}
.ip-detail-primary-publication figcaption span {
  color: #60766b;
  font-size: 11px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.ip-detail-primary-publication-fallback {
  display: flex;
  min-height: 260px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  color: #789087;
}
.ip-detail-primary-publication-fallback svg {
  width: 38px;
  height: 38px;
}
.ip-detail-primary-publication-fallback span {
  font-size: 11px;
  font-weight: 800;
}

.ip-detail-hero-facts {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1.25fr 1fr 1fr;
  margin: 29px -36px 0;
  border-top: 1px solid rgba(169, 195, 180, 0.65);
  background: rgba(255, 255, 255, 0.58);
  backdrop-filter: blur(10px);
}
.ip-detail-hero-facts div {
  min-width: 0;
  padding: 17px 22px;
}
.ip-detail-hero-facts div + div {
  border-left: 1px solid rgba(190, 210, 198, 0.62);
}
.ip-detail-hero-facts dt {
  color: #7d9187;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.04em;
}
.ip-detail-hero-facts dd {
  overflow: hidden;
  margin: 6px 0 0;
  color: #1c382a;
  font-size: 11px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ip-detail-panel,
.ip-deal-card,
.ip-process-card,
.ip-owner-card {
  border: 1px solid #dee8e2;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 15px 40px rgba(31, 69, 47, 0.065);
}

.ip-detail-panel {
  padding: 27px;
}

.ip-detail-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}
.ip-detail-panel-head h2 {
  margin: 6px 0 5px;
  color: #152a20;
  font-size: 18px;
  font-weight: 850;
  letter-spacing: -0.025em;
}
.ip-detail-panel-head > div > p:not(.ip-detail-kicker) {
  margin: 0;
  color: #788a80;
  font-size: 11px;
  line-height: 1.6;
}

.ip-detail-secure-badge,
.ip-detail-file-count {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  min-height: 29px;
  padding: 0 10px;
  border-radius: 999px;
  background: #edf7f1;
  color: #19734c;
  font-size: 9px;
  font-weight: 850;
}

.ip-detail-secure-badge svg {
  width: 14px;
  height: 14px;
}

.ip-detail-fact-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  margin: 23px 0 0;
  border-top: 1px solid #eaf0ec;
  border-left: 1px solid #eaf0ec;
}
.ip-detail-fact-grid > div {
  display: flex;
  align-items: center;
  gap: 13px;
  min-width: 0;
  padding: 17px;
  border-right: 1px solid #eaf0ec;
  border-bottom: 1px solid #eaf0ec;
}
.ip-detail-fact-grid dt {
  color: #809087;
  font-size: 9px;
  font-weight: 800;
}
.ip-detail-fact-grid dd {
  overflow: hidden;
  margin: 4px 0 0;
  color: #243d31;
  font-size: 11px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ip-detail-fact-grid dd span {
  display: inline-flex;
  margin-right: 5px;
}

.ip-detail-fact-icon {
  display: grid;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 11px;
  background: #edf6f0;
  color: #1d8055;
}
.ip-detail-fact-icon svg {
  width: 17px;
  height: 17px;
}

.ip-detail-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 18px;
}
.ip-detail-tags span {
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef7f1;
  color: #287451;
  font-size: 9px;
  font-weight: 800;
}

.ip-detail-file-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 11px;
  margin-top: 21px;
}
.ip-detail-file-grid article {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e1eae4;
  border-radius: 14px;
  background: #f8fbf9;
}
.ip-detail-file-grid strong {
  display: block;
  overflow: hidden;
  color: #263e32;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ip-detail-file-grid p {
  margin: 4px 0 0;
  color: #839188;
  font-size: 8px;
}
.ip-detail-file-grid small {
  display: block;
  margin-top: 3px;
  color: #99a59e;
  font-size: 8px;
}
.ip-detail-file-grid article > span {
  padding: 4px 6px;
  border-radius: 999px;
  background: #e4f4ea;
  color: #197449;
  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.07em;
}

.ip-detail-file-icon {
  display: grid;
  width: 35px;
  height: 35px;
  place-items: center;
  border: 1px solid #dce8e0;
  border-radius: 10px;
  background: #fff;
  color: #557066;
}
.ip-detail-file-icon svg {
  width: 17px;
  height: 17px;
}

.ip-detail-file-empty {
  display: grid;
  min-height: 150px;
  margin-top: 21px;
  place-items: center;
  align-content: center;
  border: 1px dashed #cbdcd2;
  border-radius: 15px;
  background: #f8fbf9;
  text-align: center;
}
.ip-detail-file-empty > span {
  display: grid;
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
  place-items: center;
  border-radius: 12px;
  background: #e9f2ec;
  color: #71877b;
}
.ip-detail-file-empty svg {
  width: 19px;
  height: 19px;
}
.ip-detail-file-empty strong {
  color: #4b6256;
  font-size: 11px;
}
.ip-detail-file-empty p {
  margin: 5px 18px 0;
  color: #8a9991;
  font-size: 9px;
  line-height: 1.6;
}

.ip-detail-aside {
  position: sticky;
  top: 92px;
}

.ip-deal-card {
  overflow: hidden;
  padding: 23px;
  border-color: #bfd7c9;
  background: radial-gradient(circle at 100% 0, rgba(74, 166, 108, 0.22), transparent 38%), linear-gradient(145deg, #fff 0%, #f6fbf8 100%);
  box-shadow: 0 20px 48px rgba(25, 82, 48, 0.12);
}

.ip-deal-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 18px;
  border-bottom: 1px solid #e1ebe5;
}
.ip-deal-card-head p {
  margin: 0;
  color: #71867a;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.05em;
}
.ip-deal-card-head h2 {
  margin: 6px 0 3px;
  color: #10291c;
  font-size: 27px;
  font-weight: 900;
  letter-spacing: -0.045em;
}
.ip-deal-card-head small {
  color: #8a9a91;
  font-size: 9px;
}
.ip-deal-card-head > span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 27px;
  padding: 0 9px;
  border-radius: 999px;
  background: #e1f4e8;
  color: #167147;
  font-size: 9px;
  font-weight: 850;
}
.ip-deal-card-head > span i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22aa64;
}

.ip-deal-card dl {
  display: grid;
  gap: 11px;
  margin: 17px 0;
}
.ip-deal-card dl div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.ip-deal-card dl dt {
  color: #7e8f86;
  font-size: 10px;
}
.ip-deal-card dl dd {
  overflow: hidden;
  margin: 0;
  color: #263f32;
  font-size: 10px;
  font-weight: 850;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ip-deal-primary,
.ip-deal-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 100%;
  border-radius: 11px;
  font-size: 11px;
  font-weight: 850;
  cursor: pointer;
  transition: transform 0.18s, box-shadow 0.18s, background 0.18s;
}
.ip-deal-primary svg,
.ip-deal-secondary svg {
  width: 15px;
  height: 15px;
}

.ip-deal-primary {
  height: 45px;
  border: 0;
  background: linear-gradient(135deg, #0d7d52, #126443);
  box-shadow: 0 11px 24px rgba(13, 125, 82, 0.2);
  color: #fff;
}
.ip-deal-primary:hover {
  box-shadow: 0 14px 28px rgba(13, 125, 82, 0.26);
  transform: translateY(-1px);
}

.ip-deal-secondary {
  height: 41px;
  margin-top: 9px;
  border: 1px solid #cbdad1;
  background: rgba(255, 255, 255, 0.85);
  color: #355346;
}
.ip-deal-secondary:hover {
  background: #eef7f1;
}

.ip-deal-privacy {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 13px 0 0;
  color: #87968e;
  font-size: 8px;
  text-align: center;
}
.ip-deal-privacy svg {
  flex: 0 0 auto;
  width: 12px;
  height: 12px;
}

.ip-process-card {
  padding: 21px;
}

.ip-process-card h2 {
  margin: 6px 0 18px;
  color: #1c3529;
  font-size: 15px;
  font-weight: 850;
}

.ip-process-card ol {
  position: relative;
  display: grid;
  gap: 15px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.ip-process-card ol::before {
  position: absolute;
  top: 18px;
  bottom: 18px;
  left: 16px;
  width: 1px;
  background: #dce9e1;
  content: "";
}
.ip-process-card ol li {
  position: relative;
  display: grid;
  grid-template-columns: 33px 1fr;
  align-items: start;
  gap: 11px;
}
.ip-process-card ol li > span {
  display: grid;
  width: 33px;
  height: 33px;
  place-items: center;
  border: 1px solid #d8e6dd;
  border-radius: 10px;
  background: #f3f8f5;
  color: #287752;
  font-size: 8px;
  font-weight: 900;
}
.ip-process-card ol strong {
  display: block;
  color: #344c40;
  font-size: 10px;
}
.ip-process-card ol p {
  margin: 4px 0 0;
  color: #8a9991;
  font-size: 9px;
  line-height: 1.55;
}

.ip-owner-card {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 17px;
}

.ip-owner-mark {
  display: grid;
  flex: 0 0 auto;
  width: 43px;
  height: 43px;
  place-items: center;
  border-radius: 14px;
  background: #132d20;
  color: #fff;
  font-size: 11px;
  font-weight: 900;
}

.ip-owner-card p {
  margin: 0;
  color: #819087;
  font-size: 8px;
  font-weight: 800;
}

.ip-owner-card strong {
  display: block;
  margin-top: 3px;
  color: #294337;
  font-size: 11px;
}

.ip-owner-card small {
  display: block;
  margin-top: 4px;
  color: #94a099;
  font-size: 8px;
  line-height: 1.45;
}

.ip-detail-state {
  display: grid;
  min-height: 620px;
  place-items: center;
}

.ip-detail-state-card {
  width: min(510px, 100%);
  padding: 42px;
  border: 1px solid #dae7df;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 60px rgba(28, 76, 48, 0.1);
  text-align: center;
}
.ip-detail-state-card h1 {
  margin: 9px 0;
  color: #172d22;
  font-size: 23px;
  font-weight: 850;
  letter-spacing: -0.035em;
}
.ip-detail-state-card > p:not(.ip-detail-kicker) {
  margin: 0;
  color: #798a81;
  font-size: 11px;
  line-height: 1.7;
}
.ip-detail-state-card > a,
.ip-detail-state-card > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-top: 23px;
  padding: 0 17px;
  border: 0;
  border-radius: 10px;
  background: #126e49;
  color: #fff;
  font-size: 10px;
  font-weight: 850;
  text-decoration: none;
  cursor: pointer;
}

.ip-detail-state-icon,
.ip-detail-loader {
  display: grid;
  width: 60px;
  height: 60px;
  margin: 0 auto 18px;
  place-items: center;
  border-radius: 18px;
  background: #e6f4eb;
  color: #19754c;
}
.ip-detail-state-icon svg,
.ip-detail-loader svg {
  width: 26px;
  height: 26px;
}
.ip-detail-state-icon.is-warning,
.ip-detail-loader.is-warning {
  background: #fff0df;
  color: #b66d1e;
}

.ip-detail-loader {
  position: relative;
}
.ip-detail-loader span {
  position: absolute;
  width: 28px;
  height: 28px;
  border: 2px solid rgba(19, 122, 78, 0.18);
  border-top-color: #137a4e;
  border-radius: 50%;
  animation: ip-detail-spin 1s linear infinite;
}
.ip-detail-loader span:last-child {
  width: 17px;
  height: 17px;
  border-color: rgba(19, 122, 78, 0.12);
  border-bottom-color: #36a36e;
  animation-direction: reverse;
  animation-duration: 0.7s;
}

.ip-detail-state-lines {
  display: grid;
  gap: 8px;
  width: 72%;
  margin: 24px auto 0;
}
.ip-detail-state-lines i {
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(90deg, #edf3ef 25%, #f9fbfa 50%, #edf3ef 75%);
  background-size: 200% 100%;
  animation: ip-detail-shimmer 1.4s linear infinite;
}
.ip-detail-state-lines i:nth-child(2) {
  width: 84%;
  margin: auto;
}
.ip-detail-state-lines i:nth-child(3) {
  width: 62%;
  margin: auto;
}

.ip-auth-overlay {
  position: fixed;
  z-index: 100;
  inset: 0;
  display: grid;
  padding: 20px;
  place-items: center;
  background: rgba(6, 24, 15, 0.48);
  backdrop-filter: blur(8px);
}

.ip-auth-modal {
  position: relative;
  display: grid;
  grid-template-columns: 155px minmax(0, 1fr);
  width: min(590px, 100%);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 23px;
  background: #fff;
  box-shadow: 0 35px 90px rgba(5, 28, 16, 0.3);
}

.ip-auth-close {
  position: absolute;
  z-index: 2;
  top: 14px;
  right: 14px;
  display: grid;
  width: 31px;
  height: 31px;
  padding: 0;
  place-items: center;
  border: 0;
  border-radius: 9px;
  background: #f0f5f2;
  color: #668078;
  cursor: pointer;
}
.ip-auth-close svg {
  width: 16px;
  height: 16px;
}

.ip-auth-visual {
  display: grid;
  padding: 34px 20px;
  place-items: center;
  align-content: center;
  background: radial-gradient(circle at 30% 20%, rgba(83, 181, 117, 0.35), transparent 38%), linear-gradient(145deg, #123424, #071a10);
  color: #fff;
}
.ip-auth-visual span {
  display: grid;
  width: 58px;
  height: 58px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.17);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.08);
}
.ip-auth-visual svg {
  width: 27px;
  height: 27px;
}
.ip-auth-visual small {
  margin-top: 13px;
  color: #97b9a7;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.17em;
}

.ip-auth-copy {
  padding: 35px 32px 30px;
}
.ip-auth-copy h2 {
  margin: 7px 0 8px;
  color: #172b21;
  font-size: 22px;
  font-weight: 850;
  letter-spacing: -0.035em;
}
.ip-auth-copy > p:not(.ip-detail-kicker) {
  margin: 0;
  color: #72847a;
  font-size: 11px;
  line-height: 1.7;
}
.ip-auth-copy > div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;
  margin-top: 22px;
}
.ip-auth-copy button {
  height: 40px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 850;
  cursor: pointer;
}
.ip-auth-copy button:first-child {
  border: 0;
  background: #126f49;
  color: #fff;
}
.ip-auth-copy button:last-child {
  border: 1px solid #cfdcd4;
  background: #fff;
  color: #395346;
}

@keyframes ip-detail-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ip-detail-shimmer {
  to {
    background-position: -200% 0;
  }
}
@media (max-width: 1024px) {
  .ip-detail-layout {
    grid-template-columns: 1fr;
  }
  .ip-detail-aside {
    position: static;
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
  }
  .ip-owner-card {
    grid-column: 1/-1;
  }
}
@media (max-width: 720px) {
  .ip-detail-page {
    padding: 21px 0 50px;
  }
  .ip-detail-content,
  .ip-detail-state {
    width: min(100% - 24px, 1180px);
  }
  .ip-detail-breadcrumb {
    align-items: flex-start;
  }
  .ip-detail-hero {
    padding: 24px 20px 0;
    border-radius: 19px;
  }
  .ip-detail-hero-top {
    align-items: flex-start;
    flex-direction: column;
    gap: 11px;
  }
  .ip-detail-serial {
    max-width: 100%;
  }
  .ip-detail-hero h1 {
    margin-top: 16px;
    font-size: 25px;
  }
  .ip-detail-primary-publication {
    grid-template-columns: 1fr;
  }
  .ip-detail-primary-publication img {
    max-height: 360px;
  }
  .ip-detail-primary-publication figcaption {
    padding: 15px 17px;
    border-top: 1px solid rgba(190, 210, 198, 0.72);
    border-left: 0;
  }
  .ip-detail-hero-facts {
    grid-template-columns: 1fr;
    margin: 24px -20px 0;
  }
  .ip-detail-hero-facts div {
    padding: 14px 20px;
  }
  .ip-detail-hero-facts div + div {
    border-top: 1px solid rgba(190, 210, 198, 0.62);
    border-left: 0;
  }
  .ip-detail-panel {
    padding: 21px 18px;
  }
  .ip-detail-panel-head {
    display: block;
  }
  .ip-detail-secure-badge,
  .ip-detail-file-count {
    margin-top: 12px;
  }
  .ip-detail-fact-grid,
  .ip-detail-file-grid,
  .ip-detail-aside {
    grid-template-columns: 1fr;
  }
  .ip-detail-fact-grid > div {
    padding: 14px;
  }
  .ip-owner-card {
    grid-column: auto;
  }
  .ip-detail-state {
    min-height: 530px;
  }
  .ip-detail-state-card {
    padding: 34px 22px;
    border-radius: 19px;
  }
  .ip-auth-modal {
    grid-template-columns: 1fr;
  }
  .ip-auth-visual {
    min-height: 120px;
    padding: 23px;
  }
  .ip-auth-copy {
    padding: 28px 22px 23px;
  }
}
/* 권리 요약, 기초 정보, 등록공보 열람 */
.ip-detail-hero {
  padding-bottom: 28px;
}

.ip-detail-hero h1 {
  margin-bottom: 0;
}

.ip-summary-panel h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 750;
}

.ip-invention-summary {
  margin: 15px 0 0;
  color: #536c5e;
  font-size: 14px;
  line-height: 1.9;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.ip-basic-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  margin: 22px 0 0;
  border-top: 1px solid #e5ece7;
  border-left: 1px solid #e5ece7;
}
.ip-basic-grid > div {
  min-width: 0;
  padding: 18px;
  border-right: 1px solid #e5ece7;
  border-bottom: 1px solid #e5ece7;
}
.ip-basic-grid dt {
  color: #7e8f85;
  font-size: 12px;
}
.ip-basic-grid dd {
  margin: 8px 0 0;
  color: #243f30;
  font-size: 13px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}
.ip-basic-grid strong {
  display: block;
  font-size: 15px;
  font-weight: 700;
}
.ip-basic-grid small {
  display: block;
  margin-top: 5px;
  color: #718477;
  font-size: 12px;
}

.ip-registration-link {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 7px;
  color: #2f743e;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.ip-registration-link span {
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}
.ip-registration-link:hover {
  color: #174c27;
}

.ip-document-methods {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 22px 0 18px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e5ece7;
}
.ip-document-methods button {
  min-height: 40px;
  padding: 0 17px;
  border: 1px solid #d5e1d8;
  border-radius: 9px;
  color: #6b8071;
  background: #fff;
  font-size: 13px;
  font-weight: 650;
}
.ip-document-methods button.is-selected {
  border-color: #245c40;
  color: #fff;
  background: #245c40;
}

.ip-publication-options {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 15px;
}
.ip-publication-options button {
  max-width: 100%;
  padding: 8px 11px;
  border: 1px solid #dbe5dd;
  border-radius: 7px;
  color: #607668;
  background: #fff;
  font-size: 12px;
  overflow-wrap: anywhere;
}
.ip-publication-options button.is-selected {
  border-color: #92bb8a;
  color: #356c36;
  background: #f0f7eb;
}

.ip-publication-document {
  overflow: hidden;
  border: 1px solid #dbe5dd;
  border-radius: 12px;
}

.ip-publication-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 15px 17px;
  border-bottom: 1px solid #e5ece7;
  background: #f6f9f5;
}
.ip-publication-toolbar > div {
  min-width: 0;
}
.ip-publication-toolbar strong {
  display: block;
  font-size: 12px;
  color: #365c40;
}
.ip-publication-toolbar span {
  display: block;
  margin-top: 4px;
  color: #7b8e7f;
  font-size: 11px;
  overflow-wrap: anywhere;
}
.ip-publication-toolbar a {
  flex-shrink: 0;
  color: #2f743e;
  font-size: 12px;
  font-weight: 600;
}

.ip-publication-pdf {
  display: block;
  width: 100%;
  height: 640px;
  border: 0;
  background: #f3f5f3;
}

.ip-publication-image {
  display: block;
  width: 100%;
  height: auto;
  max-height: 760px;
  object-fit: contain;
  background: #fafcfa;
}

.ip-document-help {
  margin: 0;
  padding: 12px 17px;
  color: #7e8e83;
  font-size: 11px;
  line-height: 1.7;
}

.ip-document-empty {
  padding: 35px 20px;
  border-radius: 12px;
  color: #7e8e83;
  background: #f5f8f4;
  text-align: center;
  font-size: 13px;
  line-height: 1.8;
}
.ip-document-empty strong {
  color: #536e59;
  font-size: 14px;
}
.ip-document-empty p {
  margin: 9px 0 0;
}
.ip-document-empty button {
  margin-top: 18px;
  padding: 8px 13px;
  border: 1px solid #c7d8c2;
  border-radius: 8px;
  color: #3e703b;
  background: #fff;
  font-size: 12px;
}

.ip-kipris-card {
  padding: 30px 24px;
  border: 1px solid #d5e3d3;
  border-radius: 12px;
  background: linear-gradient(120deg, #f5f9f0, #fbfcfa);
}
.ip-kipris-card h3 {
  margin: 15px 0 12px;
  color: #284e32;
  font-size: 18px;
  font-weight: 700;
}
.ip-kipris-card p {
  margin: 7px 0;
  color: #7b8e7f;
  font-size: 12px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}

.ip-kipris-mark {
  color: #28663a;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.ip-kipris-action {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  margin-top: 15px;
  padding: 0 15px;
  border-radius: 8px;
  color: #fff;
  background: #245c40;
  font-size: 12px;
  font-weight: 650;
  text-decoration: none;
}

.ip-kipris-action:hover {
  color: #fff;
  background: #183f2c;
}

.ip-attachment-list {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}
.ip-attachment-list > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 15px;
  border: 1px solid #e3ebe4;
  border-radius: 10px;
}
.ip-attachment-list > div > div {
  min-width: 0;
}
.ip-attachment-list strong {
  color: #536c5a;
  font-size: 12px;
  overflow-wrap: anywhere;
}
.ip-attachment-list small {
  display: block;
  margin-top: 4px;
  color: #8a998e;
  font-size: 11px;
}
.ip-attachment-list a {
  flex-shrink: 0;
  color: #3e703b;
  font-size: 12px;
}
.ip-attachment-list span {
  flex-shrink: 0;
  color: #8a998e;
  font-size: 11px;
}

@media (max-width: 1024px) {
  .ip-detail-main {
    display: contents;
  }
  .ip-detail-hero {
    grid-row: 1;
  }
  .ip-detail-aside {
    grid-row: 2;
    grid-template-columns: 1fr;
  }
  .ip-detail-aside .ip-process-card {
    display: none;
  }
}
@media (max-width: 720px) {
  .ip-basic-grid {
    grid-template-columns: 1fr;
  }
  .ip-detail-hero {
    padding-bottom: 23px;
  }
  .ip-publication-pdf {
    height: 450px;
  }
  .ip-kipris-card {
    padding: 24px 18px;
  }
}
.ip-detail-sale-line {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  margin-top: 18px;
  font-size: 12px;
  color: #557558;
}

.ip-detail-sale-line time {
  color: #87927e;
  font-size: 11px;
}

.ip-representative-image {
  display: block;
  width: 100%;
  max-height: 360px;
  object-fit: contain;
  margin-top: 24px;
  background: #fff;
  border: 1px solid #e5ebde;
  border-radius: 12px;
}

.ip-detail-primary-action:disabled {
  opacity: 0.5;
  cursor: default;
}

.ip-example-notice {
  margin: 0 0 20px;
  padding: 15px 18px;
  border: 1px solid #e6d8bb;
  border-radius: 10px;
  background: #faf7ef;
  color: #71592e;
}

.ip-example-notice strong {
  font-size: 13px;
  font-weight: 700;
}

.ip-example-notice p {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.8;
}

.ip-deal-primary:disabled {
  cursor: default;
  opacity: 0.6;
}`],
})
export class PageIpItemComponent implements OnInit {
    public id: string = '';
    public listing: Listing | null = null;
    public loading: boolean = true;
    public notFound: boolean = false;
    public errorMessage: string = '';
    public documentView: 'publication' | 'kipris' = 'publication';
    public selectedPublicationIndex: number = 0;
    public publicationImageFailed: boolean = false;
    public representativeImageFailed = false;
    public authModalOpen: boolean = false;
    public authActionLabel: string = '회원 전용 기능';

    constructor(@Inject( Service) public service: Service) {
        this.id = WizRoute.segment.id;
    }

    public get primaryField() {
        if (!this.listing) return '-';
        if (['상표', '디자인'].includes(this.rightTypeLabel)) {
            const numbers = classNumbers([this.listing.field, ...(this.listing.trademarkClasses || []), ...(this.listing.designClasses || [])], this.rightTypeLabel === '디자인' ? 31 : 45);
            return numbers.map((n) => n + '류').join(' · ') || this.listing.field || '-';
        }
        return patentFields(this.listing.field || this.listing.category).join(', ') || '-';
    }

    public get summaryText() {
        if (!this.listing) return '';
        if (['상표', '디자인'].includes(this.rightTypeLabel)) {
            return designatedGoodsText(this.listing) || (this.rightTypeLabel === '디자인' && this.listing.productName ? this.primaryField + ' ' + this.listing.productName : '') || this.listing.summary?.trim() || '등록된 지정상품 정보가 없습니다. 등록공보 또는 KIPRIS에서 확인해주세요.';
        }
        return this.listing.summary?.trim() || '등록된 요약이 없습니다. 등록공보 또는 KIPRIS에서 내용을 확인해주세요.';
    }

    public get saleMethods() {
        return this.listing ? [saleMethodLabel(this.listing)] : [];
    }

    public get files() {
        return this.listing && this.listing.files ? this.listing.files : [];
    }

    public get publications() {
        return this.files.filter((file) => file.documentType?.toUpperCase() === 'REGISTRATION_PUBLICATION');
    }

    public get primaryPublication(): ListingFile | null {
        return this.publications[this.selectedPublicationIndex] || this.publications[0] || null;
    }

    public get publicationUrl() {
        return this.fileUrl(this.primaryPublication);
    }

    public get rightTypeLabel() {
        const type = String(this.listing?.rightType || '').toUpperCase();
        if (type.includes('상표') || type.includes('TRADEMARK')) return '상표';
        if (type.includes('디자인') || type.includes('DESIGN')) return '디자인';
        if ((type.includes('특허') || type.includes('PATENT')) && (type.includes('실용') || type.includes('UTILITY'))) return '특허/실용신안';
        if (type.includes('실용') || type.includes('UTILITY')) return '실용신안';
        if (type.includes('특허') || type.includes('PATENT')) return '특허';
        return this.listing?.rightType || '권리';
    }

    public get summaryTitle() {
        if (['상표', '디자인'].includes(this.rightTypeLabel)) return '지정상품';
        if (this.rightTypeLabel === '실용신안') return '고안의 요약';
        return '발명의 요약';
    }

    public get kiprisUrl() {
        const registration = this.koreanNumber(this.listing?.registrationNumber);
        const application = this.listing?.isExample ? '' : this.koreanNumber(this.listing?.applicationNumber);
        const number = application.length === 13 ? application : registration;
        const prefix = number.slice(0, 2);
        let right = '';
        if (['10', '20'].includes(prefix)) right = 'kpat';
        else if (prefix === '30') right = 'kdg';
        else if (/^(4[0-9]|70)$/.test(prefix)) right = 'ktm';
        if (!right) return '';

        if (application.length === 13) {
            return 'https://www.kipris.or.kr/khome/detail/newWindow.do?' + new URLSearchParams({ applno: application, right }).toString();
        }
        if (![9, 13].includes(registration.length)) return '';
        return 'https://www.kipris.or.kr/khome/search/searchResult.do?' + new URLSearchParams({
            searchKind: 'keywordSearch',
            searchRight: right,
            queryText: registration
        }).toString();
    }

    public fileUrl(file: ListingFile | null) {
        const value = String(file?.url || '').trim();
        if (!value || (!/^https?:\/\//i.test(value) && !/^\/(?!\/)/.test(value))) return '';
        try {
            const parsed = new URL(value, typeof location !== 'undefined' && location.origin ? location.origin : 'https://market.woongbin.seasonai.net');
            return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : '';
        } catch (error) {
            return '';
        }
    }

    public isPdfFile(file: ListingFile | null) {
        if (!file) return false;
        const type = String(file.mimeType || '').toLowerCase();
        return type === 'application/pdf' || ((!type || type === 'application/octet-stream') && /\.pdf$/i.test(file.filename || ''));
    }

    public async setDocumentView(view: 'publication' | 'kipris') {
        this.documentView = view;
        await this.service.render();
    }

    public async selectPublication(index: number) {
        this.selectedPublicationIndex = index;
        this.publicationImageFailed = false;
        await this.service.render();
    }

    public async onPublicationImageError() {
        this.publicationImageFailed = true;
        await this.service.render();
    }

    private koreanNumber(value?: string) {
        const text = String(value || '').trim();
        return /^[0-9\s-]+$/.test(text) ? text.replace(/[\s-]/g, '') : '';
    }

    public get tags() {
        return this.listing && this.listing.tags ? this.listing.tags : [];
    }

    public get priceCaption() {
        if (!this.listing) return '';
        if (this.listing.isExample) return '자료에 기재된 예시 금액';
        return this.listing.price > 0 ? (this.listing.negotiable ? '협의가능' : '제시 가격') : '특정 지정가 미등록';
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        if (/^IP-[0-9]{4}-[0-9]+$/.test(this.id)) {
            location.replace('/market/cases?notice=listing-updated');
            return;
        }
        this.loading = true;
        this.notFound = false;
        this.errorMessage = '';
        this.listing = null;
        this.selectedPublicationIndex = 0;
        this.publicationImageFailed = false;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('get_listing', { id: this.id });
            if (code === 404 || data?.errorType === 'not_found' || (code === 400 && data?.errorType === 'validation')) {
                this.notFound = true;
            } else if (code !== 200) {
                this.errorMessage = data && data.message
                    ? data.message
                    : '공개 매물 상세를 불러오지 못했습니다.';
            } else {
                this.listing = data as Listing;
            }
        } catch (error) {
            this.errorMessage = '매물 정보를 불러오는 중 연결이 원활하지 않습니다.';
        }

        this.loading = false;
        await this.service.render();
    }

    public formatPrice(price: number) {
        return price > 0 ? price.toLocaleString() + '원' : '특정 지정가 미등록';
    }

    public formatDate(value: string) {
        if (!value) return '미등록';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'Asia/Seoul'
        }).format(date);
    }

    public formatFileSize(size: number) {
        if (!size) return '크기 정보 없음';
        if (size < 1024) return size + ' B';
        if (size < 1024 * 1024) return Math.ceil(size / 1024) + ' KB';
        return (size / 1024 / 1024).toFixed(1) + ' MB';
    }

    public isImageFile(file: ListingFile | null) {
        if (!file) return false;
        const type = String(file.mimeType || '').toLowerCase();
        return type.startsWith('image/') || ((!type || type === 'application/octet-stream') && /\.(png|jpe?g|gif|webp|avif|svg)$/i.test(file.filename || ''));
    }

    public async onRepresentativeImageError() { this.representativeImageFailed = true; await this.service.render(); }

    public async requestMemberAction(actionLabel: string, returnUrl: string) {
        if (this.listing?.isExample || this.listing?.status === '판매완료') return;
        const loggedIn = await this.isLoggedIn();
        if (loggedIn) {
            location.href = returnUrl;
            return;
        }

        this.authActionLabel = actionLabel;
        this.authModalOpen = true;
        await this.service.render();
    }

    public async closeAuthModal() {
        this.authModalOpen = false;
        await this.service.render();
    }

    public goLogin() {
        location.href = '/access';
    }

    public goSignup() {
        location.href = '/access?view=signup';
    }

    private async isLoggedIn() {
        try {
            await this.service.auth.update();
            return !!this.service.auth.check();
        } catch (error) {
            return false;
        }
    }
}

export default PageIpItemComponent;